/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import request from '@/api/request';
import axios from 'axios';
export * from './customer';
export * from './orderLog';
export * from './customerEvaluate';
export * from './serviceAmount';
export * from './orderReceipt';
export * from './orderMessage';
export * from './visitDetail';
export * from './orderBottomOptions'; // 获取H5  保修列表

export function getOrderListH5(data) {
  return request.get("/hd/hdprojectproduct/order", {
    params: data
  });
} // 获取上报信息

export function hdprojectproductInfo(data) {
  return request.get("/hd/hdprojectproduct/info/".concat(data));
} // 获取提交上报信息

export function hdOrderAddbymobilePhone(data) {
  return request.post("/hd/order/h5/save/addbymobilePhone", data);
} // 获取设备

export function hdProjectProductH5SaveList(data) {
  return request.get("/hd/hdprojectproduct/getProductByProject", {
    params: data
  });
}
export function hdProjectProductGetInfoByCode(data) {
  return request.get("/hd/hdprojectproduct/getInfoByCode", {
    params: data
  });
} // 获取上报信息

export function hdhdprojectproductList(data) {
  return request.post("/hd/hdprojectproduct/list", data);
}
/**
 * @description 派工单详情
 */

export function getHdOrderDetailsh5(data) {
  return request.get('/hd/order/h5/save/details', {
    params: data
  });
}
/**
 * @description 获取详情ID
 */

export function getIdByCode(data) {
  return request.get('/hd/hdprojectproduct/getIdByCode', {
    params: data
  });
}
/**
 * @description 获取详情ID
 */

export function getid(data) {
  return request.get('/getid', {
    params: data
  });
} // 获取工单列表按类型

export function getOrderCountByType(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var urlMap = {
    1: '/v2/order/getOrderListCount',
    2: '/v2/order/getOrderListCount',
    3: '/v2/order/getOrderListCount',
    4: '/v2/order/getOrderListCount',
    5: '/ordercc/count',
    6: '/v2/order/employee/getOrderListCount'
  };
  return request.get(urlMap[type], {
    params: data
  });
}
export function getOrderListByType(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var urlMap = {
    1: '/v2/order/getAllOrderList',
    2: '/v2/order/getAllOrderList',
    3: '/v2/order/getAllOrderList',
    4: '/v2/order/getAllOrderList',
    5: '/ordercc/list',
    6: '/v2/order/employee/getAllOrderList'
  };
  return request.get(urlMap[type], {
    params: data
  });
} // 获取工单列表

export function getOrderList(data) {
  return request.get('/v2/order/getAllOrderList', {
    params: data
  });
}
export function getOrderListCount(data) {
  return request.get('/v2/order/getOrderListCount', {
    params: data
  });
} // 获取首页代办事项工单列表

export function getMenuList(data) {
  return request.get('/role/menu/list', {
    params: data
  });
} // 异常工单

export function getAbnormalOrderList(data) {
  return request.get('/v2/order/abnormalOrderList', {
    params: data
  });
} // 抄送给我

export function getSendMeOrderList(data) {
  return request.get('/ordercc/list', {
    params: data
  });
} // 抄送给我数量

export function getSendMeOrderListCount(data) {
  return request.get('/ordercc/count', {
    params: data
  });
} // 获取回访工单列表

export function getAllVisitList(data) {
  return request.get('/v2/order/getAllVisitList', {
    params: data
  });
} // 获取工单类型模板列表

export function getOrderTypeTemplateList(data) {
  return request.get('/orderTypeTemplate/list', {
    params: data
  });
} // 获取服务项目列表

export function getServerItemList(data) {
  return request.get('/v2/serverItem/getItemList', {
    params: data
  });
} // 获取工单标签列表

export function getOrderTaglist(data) {
  return request.get('/v2/epTag/list', {
    params: data
  });
} // 获取工单标签列表

export function getOrderTempMsg(data) {
  return request.get('/v2/order/edit', {
    params: data
  });
} // 新建工单

export function createOrder(data, type) {
  var url = {
    1: '/v2/order/saveOrder',
    //
    2: '/v2/order/saveOrder' // 普通员工新建工单

  };
  return request.put(url[type], JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
}
export function getEditOrderDetail(data, type) {
  var url = {
    1: '/v2/order/edit',
    //
    2: '/v2/order/edit' // 普通员工编辑工单

  };
  return request.get(url[type], {
    params: data
  });
}
export function getTempTitleRule(data) {
  return request.get('/v2/temp/titleRule', {
    params: data
  });
}
export function getOrderDetail(data) {
  return request.get('/order/orderDetail', {
    params: data
  });
}
export function getOrderTab(data) {
  return request.get("/order/getOrderTab/".concat(data.orderId));
}
export function getServicePersonInfo(data) {
  return request.get("/worker/orderWorkerInfo/".concat(data.orderId));
}
export function getOrderDetailAndTab(data) {
  return new Promise(function (resolve, reject) {
    axios.all([getOrderDetail(data), getOrderTab(data)]).then(axios.spread(function (res1, res2) {
      resolve({
        res1: res1,
        res2: res2
      });
    }));
  });
}
export function getGroupList(data) {
  return request.get("/servicegroup/simplelist", data);
} // 获取指派工单picker信息

export function getAssignInfo(data1, data2) {
  return new Promise(function (resolve, reject) {
    axios.all([getOrderTaglist(data1), getOrderTaglist(data2), getGroupList()]).then(axios.spread(function (res1, res2, res3) {
      resolve({
        res1: res1,
        res2: res2,
        res3: res3
      });
    }));
  });
} // 进度分配提交

export function processDistribution(data, orderId) {
  return request.post("/order/progress/distribution/".concat(orderId), data);
} // 工单抄送

export function saveCCUsers(data) {
  return request.post('/ordercc/saveCCUsers', data);
} // 获取进度节点详细

export function getProgressNode(nodeId, orderId) {
  return request.get("/order/progress/node/".concat(nodeId, "?orderId=").concat(orderId));
} // 保存进度节点修改结果

export function saveProgressNode(nodeId, data) {
  return request.post("/order/progress/node/save/".concat(nodeId), data);
} // 暂存进度节点修改结果

export function cacheSaveProgressNode(nodeTmplId, data) {
  return request.post("/order/progress/node/cachesave/".concat(nodeTmplId), data);
} // 获取付款图片

export function getAliPayImg() {
  return request.get("/systemsetting/getByCode?code=60001");
}
export function getWxPayImg() {
  return request.get("/systemsetting/getByCode?code=60002");
} // 工单 明细控件 tab列表

export function getOrderDetailCtrlList(data) {
  return request.get("/detailcontrol/orderDetailControllerList", {
    params: data
  });
} // 明细控件 列表表头

export function getDetailCtrlFieldColumn(data) {
  return request.get("/detailcontrol/getFieldName", {
    params: data
  });
}
export function saveDetailCtrlFormObj(data) {
  return request.post("/detailcontrol/saveObjCtrlsField", data);
} // 明细控件 保存自定义表单 新增

export function saveDetailCtrlForm(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var map = {
    1: "/detailcontrol/saveField",
    // order
    2: '/detailcontrol/customer/saveField',
    // customer
    3: '/detailcontrol/customerProduct/saveField',
    // customer product
    4: '/detailcontrol/event/saveField',
    5: '/detailcontrol/project/saveField',
    24: '/formcontrol/project/saveField'
  };
  return request.post(map[type], data);
} // 明细控件 保存自定义表单 编辑

export function saveDetailCtrlFormEdit(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var map = {
    1: "/detailcontrol/updateField",
    // order
    2: '/detailcontrol/customer/updateField',
    // customer
    3: '/detailcontrol/customerProduct/updateField',
    // customer product
    4: '/detailcontrol/event/updateField',
    5: '/detailcontrol/project/updateField',
    24: '/formcontrol/project/updateField'
  };
  return request.post(map[type], data);
} // 明细控件 table 数据

export function getDetailCtrlTableList(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var map = {
    1: "/detailcontrol/fieldValues",
    // order
    2: '/detailcontrol/customer/fieldValues',
    // customer
    3: '/detailcontrol/customerProduct/fieldValues',
    // customer product
    4: '/detailcontrol/event/fieldValues',
    5: '/detailcontrol/project/fieldValues',
    24: '/formcontrol/project/fieldValues'
  };
  return request.get(map[type], {
    params: data
  });
} // 明细控件 删除table列表项

export function deleteDetailCtrlTableList(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var map = {
    1: "/detailcontrol/delete",
    // order
    2: '/detailcontrol/customer/delete',
    // customer
    3: '/detailcontrol/customerProduct/delete',
    // customer product
    4: '/detailcontrol/event/delete',
    5: '/detailcontrol/project/delete',
    24: '/formcontrol/project/delete'
  };
  return request.delete(map[type], {
    params: data
  });
} // 明细控件 自定义表单列表

export function getDetailCtrlCustomField(data) {
  return request.get("/detailcontrol/forminfo", {
    params: data
  });
} // 查询自定义工单列表配置

export function getOrderTempShowList(data) {
  return request.get("/v2/temp/queryOrderListSetting", {
    params: data
  });
}
export function putPhonelog(data) {
  return request.put("/v2/order/phonelog", data);
}
export function updateLocation(data) {
  return request.post("/user/updateLocation", data);
}
export function getDetailcontrolObj(data) {
  return request.get("/detailcontrol/objDetailControllerList", {
    params: data
  });
}
export function getProductAttrList(data) {
  return request.get("/v2/product/attrList", {
    params: data
  });
}
export function getProductAttrCount(data) {
  return request.get("/customer/product/attrCount", {
    params: data
  });
}
export function putReduction(data) {
  return request.put("/v2/order/reduction", data);
}
export function deleteOrder(data) {
  return request.delete("/order/delAllOrder", {
    params: data
  });
}
export function orderExportPdf(data) {
  return request.post("/export/orderPdf", data);
}
export function getProcessDefault(data) {
  return request.get('/order/progress/defaultUser', {
    params: data
  });
}
export function getTempDispatch(data) {
  return request.get('/v2/processSet/getDefaultDispatch', {
    params: data
  });
}
/**
 * @api2.9
 */

export function getMapViewByArea(data) {
  return request.get('/map/view/countInfoByArea', {
    params: data
  });
}
export function getMapViewOrderListByArea(data) {
  return request.get('/map/view/listInfoByArea', {
    params: data
  });
}
/**
 * @api2.93
 */

export function getServerItemDetail(data) {
  return request.get('/v2/serverItem/getItemDetails/ignoreState', {
    params: data
  });
}
export function getServerItemLog(data) {
  return request.get('v2/serverItem/log', {
    params: data
  });
}
export function getSpareDetail(data) {
  return request.get('v2/spare/sparePart/details/ignoreState', {
    params: data
  });
}
export function getSpareDetailLog(data) {
  return request.get('/v2/spare/sparePart/log', {
    params: data
  });
}
export function getWarsehouseList(data) {
  return request.get('/warehouse/list', {
    params: data
  });
}
export function getWarsehouseApplyList(data) {
  return request.get('/warehouse/apply/list', {
    params: data
  });
}
export function getSpareEpDetail(data) {
  return request.get('/v2/spare/getEpDetail', {
    params: data
  });
} // 不带仓库ID

export function getSpareListV2(data) {
  return request.get('/v2/spare/spareList', {
    params: data
  });
}